import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './../firebase-config';
import Spinner from './Spinner';
import { Link } from 'react-router-dom';

export default function Aside({ show = true }) {
  const [asideData, setAsideData] = useState(null);
  const asideDocRef = doc(db, 'website-data', 'aside-data');

  const getAsideData = async () => {
    const data = await getDoc(asideDocRef);
    setAsideData(data.data());
  };

  useEffect(() => {
    getAsideData();
  }, []);

  return (
    <>
      {show && (
        <>
          {asideData ? (
            <aside>
              <div class='profile-img-wrapper'>
                <img src={asideData && asideData['photo-url']} alt='profile' />
              </div>
              <h1 class='profile-name'>{asideData && asideData['name']}</h1>
              <div class='text-center'>
                <span class='badge badge-white badge-pill profile-designation'>
                  {asideData && asideData['title']}
                </span>
              </div>
              <nav class='social-links'>
                {asideData &&
                  asideData['socialMedia'].map((singleData) => {
                    return (
                      <a
                        href={singleData['link']}
                        class='social-link'
                        style={{ color: 'rebeccapurple' }}
                      >
                        <i class={singleData['icon']}></i>
                      </a>
                    );
                  })}
                {/* <a href='#!' class='social-link'>
          <i class='fab fa-facebook-f'></i>
        </a>
        <a href='#!' class='social-link'>
          <i class='fab fa-twitter'></i>
        </a>
        <a href='#!' class='social-link'>
          <i class='fab fa-behance'></i>
        </a>
        <a href='#!' class='social-link'>
          <i class='fab fa-dribbble'></i>
        </a>
        <a href='#!' class='social-link'>
          <i class='fab fa-github'></i>
        </a> */}
              </nav>
              <div class='widget'>
                <h5 class='widget-title'>personal information</h5>
                <div class='widget-content'>
                  {asideData &&
                    asideData['personal-information'].map((singleData) => {
                      return (
                        <p>
                          {singleData['title']} : {singleData['data']}
                        </p>
                      );
                    })}
                  {/* <p>BIRTHDAY : 15 April 1990</p> */}
                  {/* <p>WEBSITE : www.example.com</p> */}
                  {/* <p>PHONE : +1 123 000 4444</p> */}
                  {/* <p>MAIL : your@example.com</p> */}
                  {/* <p>Location : California, USA</p> */}
                  {/* <button class="btn btn-download-cv btn-primary rounded-pill">
            {" "}
            <img
              src="assets/images/download.svg"
              alt="download"
              class="btn-img"
            />
            DOWNLOAD CV{" "}
          </button> */}
                </div>
              </div>
              <div class='widget card'>
                <div class='card-body'>
                  <div class='widget-content'>
                    <h5
                      class='widget-title card-title'
                      style={{ color: 'rebeccapurple' }}
                    >
                      Current Courses
                    </h5>
                    <div style={{ textAlign: 'left' }}>
                      {asideData &&
                        asideData['current-courses'].map((singleData) => {
                          return (
                            <li
                              style={{
                                'white-space': 'nowrap',
                                overflow: 'hidden',
                                'text-overflow': 'ellipsis',
                                'max-width': '300px',
                              }}
                            >
                              <Link
                                to={`/courses/${singleData['link']}`}
                                // target={'_blank'}
                                style={{ color: 'initial' }}
                              >
                                {singleData['title']}
                              </Link>
                            </li>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div class='widget card'>
                <div class='card-body'>
                  <div class='widget-content'>
                    <h5
                      class='widget-title card-title'
                      style={{ color: 'rebeccapurple' }}
                    >
                      Latest Videos
                    </h5>
                    <div style={{ textAlign: 'left' }}>
                      {asideData &&
                        asideData['latest-videos'].map((singleData) => {
                          return (
                            <li
                              style={{
                                'white-space': 'nowrap',
                                overflow: 'hidden',
                                'text-overflow': 'ellipsis',
                                'max-width': '300px',
                              }}
                            >
                              <a
                                href={singleData['link']}
                                target={'_blank'}
                                style={{ color: 'initial' }}
                              >
                                {singleData['title']}
                              </a>
                            </li>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div class="widget card">
        <div class="card-body">
          <div class="widget-content">
            <h5 class="widget-title card-title">INTERESTS</h5>
            <p>Video games</p>
            <p>Finance</p>
            <p>Basketball</p>
            <p>Theatre</p>
          </div>
        </div>
      </div> */}
            </aside>
          ) : (
            <Spinner />
          )}
        </>
      )}
    </>
  );
}
